import { render, staticRenderFns } from "./productPatient.vue?vue&type=template&id=6840026c&scoped=true"
import script from "./productPatient.vue?vue&type=script&lang=js"
export * from "./productPatient.vue?vue&type=script&lang=js"
import style0 from "./productPatient.vue?vue&type=style&index=0&id=6840026c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6840026c",
  null
  
)

export default component.exports